import React, { useState, useEffect } from 'react';
import { Rose } from '@ant-design/plots';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

const SalesModel = () => {

    const [modelsSold, setModelsSold] = useState('')

    useEffect(()=>{
        fetch(`${FetchVariable.Heroku}/sales/get-sales-customer`)
        .then((response) => response.json())
        .then((json) => {            
            setModelsSold(json)
        })
        .catch((error) => {
            console.log('fetch data failed', error);
        });
    },[])

   const data = []; 
   for (const element of modelsSold) {
        data.push(element)
   }

   const circleData = []
   for (const e of modelsSold){
    circleData.push({"name":e.Make + e.Model,"value":e.VehiclesSold})
   }


   let styles = {
       marginTop: '50px',
       marginBottom: '50px'
   };
   
  const config = {
    data,
    xField: 'Model',
    yField: 'VehiclesSold',
    seriesField: 'Make',
    height: 600,
    width: 600,
    radius: 0.9,
    legend: {
      layout: 'horizontal',
      position: 'bottom',
    },
  };

  return (
      <div className="container">
        <h1 className="text-center" style={styles}>Vehicles Sold by Model</h1>
            <Rose {...config} />
        </div>
  );
};

export default SalesModel